import * as React from 'react'
import { CheckinAnswersUpdatedNotification } from '../../../../store/modules/notifications'
import { FormattedDateTime } from 'components/formatted-datetime'

export type CheckinAnswersUpdatedProps = {
  notification: CheckinAnswersUpdatedNotification
}

export const CheckinAnswersUpdatedContent: React.VFC<
  CheckinAnswersUpdatedProps
> = (props) => {
  const { notification } = props

  return (
    <div className="flex flex-col gap-y-0.5">
      <div>
        {notification.author && (
          <strong className="font-bold">{notification.author.fullName}</strong>
        )}{' '}
        has updated their Check-in answers
      </div>
      <div className="flex flex-row items-center justify-between gap-2 flex-wrap">
        <span className="text-theme-40">View Check-in</span>
        <FormattedDateTime
          className="text-gray-600 text-xs"
          date={notification.createdAt}
        />
      </div>
    </div>
  )
}
